// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XuT1","top":"styles_top__21afQ","left":"styles_left__3ZsM9","description":"styles_description__1WVif"};